import PropTypes from 'prop-types'
import { idPropType } from '../common/id-prop-type'
import { reducedWeeklyRestPeriodCompensationRestPropType } from '../drivers/reduced-weekly-rest-period-compensation-rest-prop-type'
import { durationRestPropType } from '../drivers/duration-rest-prop-type'

/**
 * @typedef {Object} RemainingDrivingTime
 * @property {number} [currentExtendedDailyDrivingTimes]        - The number of extended daily driving times already
 *                                                                taken within the current week
 * @property {number} [currentReducedDailyRestPeriods]          - The number of reduced daily rest periods taken since
 *                                                                the last daily or weekly rest period
 * @property {string} driverId                                  - Id of the driver
 * @property {boolean} [infringements]                          - Determines that the driver violated some driving rules
 * @property {number} [maximumExtendedDailyDrivingTimes]        - The maximum number of extended daily driving times
 *                                                                that can be taken within a week
 * @property {number} [maximumReducedDailyRestPeriods]          - The maximum number of allowed reduced daily rest
 *                                                                periods
 * @property {string} [maximumWeeklyDrivingTime]                - The maximum 'weekly driving time' for the current week
 *
 * @property {DurationRest} [remainingDailyDrivingTime]         - The remaining driving time for today
 * @property {ReducedWeeklyRestPeriodCompensationRest[]} [remainingReducedWeeklyRestPeriodCompensations]
 *                                                              - List of reduced weekly rest periods which still have
 *                                                                to be compensated
 *
 * @property {DurationRest} [remainingWeeklyDrivingTime]        - The remaining 'weekly driving time' the driver can
 *                                                                take for driving activity in the current week.
 * @property {DurationRest} [remainingWeeklyDrivingTimeNextWeek]- The remaining 'weekly driving time' for next week.

 * @property {DurationRest} [timeToNextBreakPeriod]             - The duration to the latest possible time at which
 *                                                                a new break period must be started
 * @property {DurationRest} [timeToNextRestPeriod]              - The duration to the latest possible time at which
 *                                                                a new rest period must be started
 *
 * TODO RPT-159 PropType is outdated and needs to be updated to meet current API specifications
 */
export const remainingDrivingTimePropType = PropTypes.shape({
    currentExtendedDailyDrivingTimes: PropTypes.number,
    currentReducedDailyRestPeriods: PropTypes.number,
    driverId: idPropType,
    infringements: PropTypes.bool,
    maximumExtendedDailyDrivingTimes: PropTypes.number,
    maximumReducedDailyRestPeriods: PropTypes.number,
    maximumWeeklyDrivingTime: PropTypes.string,
    remainingDailyDrivingTime: durationRestPropType,
    remainingReducedWeeklyRestPeriodCompensations: PropTypes.arrayOf(reducedWeeklyRestPeriodCompensationRestPropType),
    remainingWeeklyDrivingTime: durationRestPropType,
    remainingWeeklyDrivingTimeNextWeek: durationRestPropType,
    timeToNextBreakPeriod: durationRestPropType,
    timeToNextRestPeriod: durationRestPropType
})
